import { render, staticRenderFns } from "./productBrands.vue?vue&type=template&id=640d8024&scoped=true&"
import script from "./productBrands.vue?vue&type=script&lang=js&"
export * from "./productBrands.vue?vue&type=script&lang=js&"
import style0 from "./productBrands.vue?vue&type=style&index=0&id=640d8024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640d8024",
  null
  
)

export default component.exports